import type {
	ConversationHistorySourceResult,
	ConversationImportResult,
} from "@signalist/shared-types";

/** One sentence of the "Load earlier conversation" answer. */
export interface EarlierConversationResultLine {
	source: "linkedin" | "email";
	key: string;
	count: number;
	isError: boolean;
}

const SOURCE_PREFIX: Record<"linkedin" | "email", string> = {
	linkedin: "inbox.thread.earlierConversation.linkedin",
	email: "inbox.thread.earlierConversation.email",
};

/** The two sources in the order the chat names them. */
const SOURCES = ["linkedin", "email"] as const;

const lineFor = (
	key: "linkedin" | "email",
	result: ConversationHistorySourceResult
): EarlierConversationResultLine => ({
	source: key,
	// The status is a closed set (CONVERSATION_HISTORY_STATUSES), each with its own sentence.
	key: `${SOURCE_PREFIX[key]}.${result.status}`,
	count: Number(result.imported) || 0,
	isError: result.status === "FAILED",
});

/**
 * What each source answered, as one translated sentence each (PREC-4305). A failed lookup is an
 * error line of its own — "could not read" — never the "nothing found" sentence.
 */
export const earlierConversationResultLines = (
	result: ConversationImportResult
): EarlierConversationResultLine[] => SOURCES.map((key) => lineFor(key, result[key]));
